import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../api/auth-context';

/**
 * The SPA side of the OIDC callback. The backend redirects here with the access
 * token in the URL fragment (`#access_token=…&expires_in=…&workspace_id=…`) and
 * the refresh token already set as an HttpOnly cookie. This component stores the
 * access token and continues into the app.
 */
export function AuthCallback(): JSX.Element {
  const auth = useAuth();
  const navigate = useNavigate();
  // Router location, not window.location: the address bar is masked to the root.
  const { hash, search } = useLocation();

  useEffect(() => {
    const fragment = new URLSearchParams(hash.slice(1));
    const accessToken = fragment.get('access_token');
    const expiresIn = Number.parseInt(fragment.get('expires_in') ?? '0', 10);
    const workspaceId = fragment.get('workspace_id');
    const error = new URLSearchParams(search).get('error');

    if (accessToken && workspaceId) {
      auth.login(accessToken, Number.isFinite(expiresIn) ? expiresIn : 0, workspaceId);
      navigate('/', { replace: true });
    } else {
      navigate(error ? `/login?error=${encodeURIComponent(error)}` : '/login', { replace: true });
    }
  }, [auth, navigate, hash, search]);

  return (
    <main className="page">
      <p role="status">Completing sign-in…</p>
    </main>
  );
}
